import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ButtonVariationEnum } from '../../../ui/Button/types';
import i18n from '../../../utils/i18n';
import Button from '../../../ui/Button';
import { ICategoryShort } from '../../../utils/types';
import { pathsApi } from '../../../router/paths';
import DragAndDropPopup from '../../../components/DragAndDrop/dragAndDropPopup';
import { FetchApi } from '../../../utils/fetch/fetchApi';
import { setNotificationSuccess } from '../../../state/reducers/notification';
import { AppDispatch } from '../../../state';

interface ISortRootCategories {
    categories?: Array<ICategoryShort>;
    setCategoryCallback: (id: Array<ICategoryShort>) => void;
}

const SortRootCategories = ({ categories, setCategoryCallback }: ISortRootCategories) => {
    const [isOpen, handleOpen] = useState<boolean>(false);
    const dispatch = useDispatch<AppDispatch>();

    const handleSaveSort = async (payload: Array<{ id: number; order: number }>) => {
        const response = await FetchApi.post<Array<ICategoryShort>>(pathsApi.categorySort, {
            items: payload,
        });

        if (response) {
            dispatch(setNotificationSuccess(i18n.general.updatedSuccessful));
            setCategoryCallback(response);
            return true;
        }
        return false;
    };

    return (
        <>
            <Button
                onClick={() => {
                    handleOpen(true);
                }}
                variation={ButtonVariationEnum.SOFT}
            >
                {i18n.category.changeCategoryOrder}
            </Button>
            {isOpen && (
                <DragAndDropPopup
                    isOpen={!!isOpen}
                    handleClose={() => handleOpen(false)}
                    items={categories
                        ?.filter((item) => item.depth === 0)
                        .map((item) => ({
                            id: item.id,
                            content: item.name,
                        }))}
                    submit={handleSaveSort}
                />
            )}
        </>
    );
};

export default SortRootCategories;
